import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flex: 1
    },

    footer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#535353',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        marginTop: 50,
        overflow: 'hidden'
    },

    footerContent: {
        flexDirection: 'column',
        justifyContent:'center',
        alignItems: 'center',
        width: '80%',
    },

    footerText: {
        fontWeight: 'bold',
        fontSize: 14,
        color: '#f7f7f7',
        fontFamily: 'Montserrat',
        textAlign: 'center',
    },

    footerTitle: {
        fontSize: 24,
        color: '#FFC646',
        fontFamily: 'Montserrat',
        fontWeight: '700',
        marginTop: 20,
        textAlign: 'center',
    },

    legalsRowView: {
        flex: 1,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        marginTop: 32,
        padding: 12
    },

    legalsColView: {
        flex: 1,
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        marginTop: 32,
        padding: 12
    },

    footerLink: {
        fontSize: 16,
        color: 'white',
        fontFamily: 'Montserrat',
        fontWeight: '600',
        textAlign: 'center',
    }
});